import styled from 'styled-components'
import { themeColor, themeFontFamily } from 'LibNeo'

export enum TextType {
	BODY1 = 'body1',
	BODY2 = 'body2',
	BUTTON = 'button',
	CAPTION = 'caption',
	OVERLINE = 'overline',
}

export enum FontWeightType {
	LIGHT = 'light',
	REGULAR = 'regular',
	MEDIUM = 'medium',
	SEMIBOLD = 'semibold',
	BOLD = 'bold',
}
const fontWeightValue = {
	[FontWeightType.LIGHT]: 300,
	[FontWeightType.REGULAR]: 400,
	[FontWeightType.MEDIUM]: 500,
	[FontWeightType.SEMIBOLD]: 600,
	[FontWeightType.BOLD]: 700,
}

const variants: Record<
	`${TextType}`,
	{
		fontSize: string
		lineHeight: string
		fontFamily?: string
		color?: number
		transform?: string
	}
> = {
	[TextType.BODY1]: {
		fontSize: '16px',
		lineHeight: '24px',
	},
	[TextType.BODY2]: {
		fontSize: '14px',
		lineHeight: '20px',
	},
	[TextType.BUTTON]: {
		fontSize: '14px',
		lineHeight: '16px',
		fontFamily: 'SBSansInterface',
	},
	[TextType.CAPTION]: {
		fontSize: '12px',
		lineHeight: '20px',
		color: 6,
	},
	[TextType.OVERLINE]: {
		fontSize: '12px',
		lineHeight: '32px',
		transform: 'uppercase',
	},
}

export const Text = styled.div<{
	type: TextType | string
	colorIndex?: number
	fontWeight?: FontWeightType
}>`
	font-size: ${({ type }) => variants[type].fontSize};
	line-height: ${({ type }) => variants[type].lineHeight};
	font-family: ${({ type }) => themeFontFamily(variants[type].fontFamily ?? 'SBSansText')};
	color: ${({ type, colorIndex }) => themeColor('gray', colorIndex ?? variants[type].color ?? 8)};
	text-transform: ${({ type }) => variants[type].transform ?? 'none'};
	font-weight: ${({ fontWeight = FontWeightType.REGULAR }) => fontWeightValue[fontWeight]};
`
